<template>
  <div>
    <div class="study-references">
      <reference-list-item
        v-for="item in references"
        :key="item.id"
        :image="item.thumbnail"
        :title="item.title"
        :url="item.url"
        :id="item.id"
        @removed="removeReference(item.id)"
      />
    </div>

    <div class="study-references__add">
      <text-field
        v-model="newReference"
        type="single"
        label="Reference URL"
        name="newref"
        class="study-references__text-field"
      />
      <button class="text-button" @click="addNewReference">
        <font-awesome-icon icon="plus-circle" size="lg" />
      </button>
    </div>
  </div>
</template>

<script>
import ReferenceListItem from './ReferenceListItem';
import TextField from '@/components/form/TextField';
import maddyApi from '@/services/maddyApi';

export default {
  name: 'study-references',
  components: { TextField, ReferenceListItem },
  data: function() {
    return {
      newReference: '',
      references: [],
    };
  },
  mounted() {
    this.getStudyReferences();
  },
  methods: {
    async getStudyReferences() {
      const endpoint = `/studies/${this.$route.params.id}/references`;
      const response = await maddyApi.get(endpoint);

      response.data.forEach(reference => {
        this.references.push(reference);
      });
    },
    validateReference() {
      const regexp = /^(?:(?:https?|ftp):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/;

      if (regexp.test(this.newReference)) {
        return true;
      } else {
        return false;
      }
    },
    removeReference(id) {
      const index = this.references.findIndex(x => x.id === id);
      if (index > -1) {
        this.references.splice(index, 1);
      }
    },
    async addNewReference() {
      if (!this.validateReference()) return;

      try {
        const endpoint = `/studies/${this.$route.params.id}/reference`;
        const body = { referenceURL: this.newReference };
        const response = await maddyApi.post(endpoint, body);

        this.references.push(response.data);
      } catch (err) {
        // console.log(err);
        // TODO: Handle error
      }

      this.newReference = '';
    },
  },
};
</script>

<style lang="scss">
.study-references {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 1px;

  &__item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 4px 8px;

    &:nth-child(even) {
      background: rgb(247, 247, 247);
    }

    a {
      overflow: hidden;
      max-height: 1.4rem;
      padding-right: 8px;
      color: color('denotive', 'info');
      text-decoration: underline;
    }
  }

  &__add {
    border-top: 1px solid color('grey');
    padding-top: 16px;
    margin-top: 16px;
    display: flex;
  }

  &__text-field {
    flex: 7;
    margin-right: 8px;
  }
}
</style>
